import type { LifeProfile } from '../types/life'
import { horizonOf } from './lifeGrid'
import { plural } from './format'

export interface RemainingCounter {
  id: string
  value: number
  label: string
  /** loss — то, что не «ещё случится», а наоборот уйдёт из остатка */
  tone?: 'loss'
}

const DAY_MS = 86_400_000
const YEAR_DAYS = 365.2425
const SLEEP_SHARE = 1 / 3

/**
 * Счётчики «сколько ещё раз» — считаются только из даты рождения и горизонта,
 * поэтому релевантны любому взрослому без единого дополнительного вопроса.
 *
 * Два правила отбора:
 * 1. Каденции разные (год / неделя / день) — иначе все числа выходят
 *    одинаковыми и удар пропадает.
 * 2. Единица должна быть телесной: то, что человек делает сам, а не то,
 *    что происходит на небе. «Проснуться» и «пятничный вечер» бьют,
 *    «полнолуние» и «Олимпиада» — нет.
 */
export function remainingCounters(profile: LifeProfile, now: Date): RemainingCounter[] {
  const days = Math.max(0, (horizonOf(profile).getTime() - now.getTime()) / DAY_MS)
  const years = days / YEAR_DAYS
  const weeks = days / 7

  const birthdays = Math.floor(years)
  const fridays = Math.floor(weeks)
  const weekends = Math.floor(weeks) * 2
  const mornings = Math.floor(days)
  const sleep = Math.floor(days * SLEEP_SHARE)

  return [
    { id: 'birthdays', value: birthdays, label: plural(birthdays, ['день рождения', 'дня рождения', 'дней рождения']) },
    {
      id: 'fridays',
      value: fridays,
      label: plural(fridays, ['пятничный вечер', 'пятничных вечера', 'пятничных вечеров']),
    },
    { id: 'weekends', value: weekends, label: plural(weekends, ['выходной', 'выходных', 'выходных']) },
    { id: 'mornings', value: mornings, label: 'раз проснуться' },
    {
      id: 'sleep',
      value: sleep,
      label: plural(sleep, ['день уйдёт на сон', 'дня уйдёт на сон', 'дней уйдёт на сон']),
      tone: 'loss',
    },
  ]
}
